import step1 from './useStep1'
import step2 from './useStep2'
import step3 from './useStep3'
// import step4 from './useStep4'
import register1 from './register1'
import register from './useRegister'
import useSchoolFields from './useSchoolFields'

export { step1, step2, step3, register1, register }
export default { useSchoolFields }